export default __webpack_public_path__ + "static/media/omission.e12da796.png";